import { Box, Button, Flex, Input, Select } from "@chakra-ui/react";
import styled from "styled-components";

export const ContainerConsulta = styled(Box)`
  width: 100%;
  height: 85vh;
  margin-top: 15px;
`;
export const ConsultaContainerText = styled(Box)`
  background-color: #80bd01;
  padding: 15px 0;
  font-family: Akrobat;
  h1 {
    color: #fff;
    font-size: 23px;
    font-weight: 400;
    text-align: center;
  }
`;
export const ContainerConsultaBox = styled(Box)`
  font-family: Akrobat;
  background-color: white;
  box-shadow: 2px 2px 5px 2px gray;
  width: 100%;
  margin-inline: 1rem;
  height: 510px;
  margin-top: 1rem;
  justify-content: center;
  align-items: center;
  border-radius: 15px;
  margin-bottom: 2rem;
`;
export const InputConsulta = styled(Input)`
  margin-right: 1rem;
  padding: 4;
`;
export const SelectConsulta = styled(Select)``;
export const ButtonConsulta = styled(Button)`
  margin-top: 1rem;
  color: white;
`;

export const StatusFunilVendas = styled.span`
  display: flex;
  align-items: center;
  gap: 0.5rem;

  &::before {
    content: "";
    width: 0.7rem;
    height: 0.7rem;
    border-radius: 50%;
    background: ${(props) => props.color};
  }
`;
